import Tag from "@/domain/tag/Tag";
import ClientBase from "../ClientBase";

class TagClient extends ClientBase {
    async createTag(newTag) {
        // Create response carries only the new id; the caller reloads the list.
        return await this.post('api/v1/tags', newTag);
    }

    async getTagsByOrganizationId(organizationId) {
        const data = await this.get(`api/v1/tags/${organizationId}`);
        return data?.map(t => new Tag(t)) ?? [];
    }

    async updateTag(tag) {
        const data = await this.put(`api/v1/tags/${tag.organizationId}/${tag.id}`, tag);
        return data ? new Tag(data) : null;
    }
}

export default new TagClient();
